import { render, staticRenderFns } from "./OutletType.vue?vue&type=template&id=9bccdc36"
import script from "./OutletType.vue?vue&type=script&lang=js"
export * from "./OutletType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports